(ns ncr.reports.explain
  (:require
   [cljs.pprint :as pp]
   [clojure.core.match :refer [match]]
   [uix.core.alpha :as uix]
   [ncr.etc.pf :as pf]
   [ncr.etc.util :as u]
   [ncr.widgets.grid :as grid]
   [ncr.widgets.core :as w]
   [ncr.etc.pubsub :as ps]
   [ncr.me :as me]
   [ncr.reports.grid-cell :as gc]
   [ncr.reports.common :as r-common]
   [ncr.fragment.common :as fragment-common]
   [ncr.fragment.props.money.input :as props-money]
   [ncr.fragment.props.timesheet :as props-timesheet]
   [ncr.reports.explain-model :as em]
   [ncr.reports.explain-fragment :as create]))

(defn- pprint [in]
  (if (some? in)
    (binding [pp/*print-right-margin* 80]
      (with-out-str (pp/pprint in)))
    ""))

(defn- time-span [& {:keys [time ktu] :or {time :time ktu :ktu}}]
  (fn [ctx]
    (let
      [^js time (get ctx time)
       ^js ktu (get ctx ktu)]
      (when time
        [:span
         (str (.toString time) "H"
           (when ktu
             (u/format " (%s%)" (-> ktu (.precision 3) (.times 100)))))]))))

(defn- cclass [column]
  (str "c-" (name column)))

(defn- tclass [{:keys [type]}]
  (str "t-" (name type)))

(def columns
  (clj->js
    [(grid/column-accessor :name [{:class (cclass :name)} "Name"]
       (fn [cell-context]
         (let [value (grid/value cell-context)]
           [{:class [(cclass :name) (tclass value)]}
            (match value
              {:type :group :label label}
              label

              {:type :data :name name}
              [{:class [:pf-u-pl-2xl]}
               (gc/expandable-heading
                 name)]

              {:type :data :fragment fragment :meta meta}
              [{:class [:pf-u-pl-2xl]}
               (gc/expandable-heading
                 [pf/l-flex
                  {:justify-content :justify-content-flex-start
                   :align-items :align-items-center
                   :flex-wrap :nowrap}
                  [:div {:class :ncr-u-text-truncate__container}
                   [fragment-common/c-name
                    {:open-in-new-tab? true
                     :editable? false
                     :style {:font-size :inherit}
                     :class :pf-u-p-0}
                    fragment]]
                  (let
                    [labels
                     (let [{:keys [labels ignore-label?]} (grid/table-meta cell-context)]
                       (->> (get fragment :labels)
                         (map (juxt labels identity))
                         (filter first)
                         (filter (comp (complement ignore-label?) first))
                         (sort-by first)
                         (map second)))]
                    [:<>
                     (when (seq labels)
                       [pf/l-flex-item {:flex :flex-none}
                        [fragment-common/c-labels {:open-in-new-tab? true :track-origin "Report"} (assoc fragment :labels labels)]])

                     (when (= (:kind meta) :estimated)
                       (let [me (uix/context me/*context*)]
                         [grid/tools
                          [:plus
                           (u/isolate*
                             #(create/create-fragment! me
                                {:name (:name fragment)
                                 :month (:month value)
                                 :netto (:value value)
                                 :meta meta
                                 :labels labels}))]]))])])]

              {:type :spacer}
              [:div {:style {:height "1em"}}]
              _
              nil)])))

     (grid/column-accessor :value [{:class (cclass :value)} "Value"]
       (fn [cell-context]
         (let [value (grid/value cell-context)]
           [{:class [(cclass :value) (tclass value)]}
            (case (:type value)
              :data
              (let [fragment-id (get-in value [:fragment :id])]
                (if (and fragment-id (-> cell-context grid/table-meta :kind (not= :estimated)))
                  (when-let [value (:value value)]
                    [props-money/c-inline-input
                     {:fragment-id fragment-id
                      :value value
                      :on-updated #(ps/pub! [:ncr.reports.core/reload])}])

                  ((-> :value
                     (gc/stringify-value)
                     (gc/colorize))
                   value)))
              :summary
              ((-> :value
                 (gc/stringify-value)
                 (gc/colorize)
                 (gc/colorize-border)) value)

              (constantly nil))])))

     (grid/column-accessor :time [{:class (cclass :time)} "Time"]
       (fn [cell-context]
         (let [value (grid/value cell-context)]
           [{:class [(cclass :time) (tclass value)]}
            (case (:type value)
              :data
              (let
                [time-str ((time-span {:time :project-time}) value)]
                (if-let [fragment-id (get-in value [:fragment :id])]
                  (when (:project-time value)
                    [pf/c-button
                     {:variant :link
                      :class :ncr-m-inline-edit
                      :icon-position :right
                      :icon [w/c-mdi-icon {:icon :pencil}]
                      :on-click
                      (fn [_]
                        (props-timesheet/edit-fragment-property
                          {:id fragment-id
                           :on-updated #(ps/pub! [:ncr.reports.core/reload])}))}
                     time-str])
                  time-str))
              :summary
              ((-> (time-span {:time :project-time})
                 (gc/colorize-border))
               value)
              (constantly nil))])))

     (grid/column-accessor :team-time [{:class (cclass :team-time)} "Total Time"]
       (fn [cell-context]
         (let [value (grid/value cell-context)]
           [{:class [(cclass :team-time) (tclass value)]}
            (case (:type value)
              :data
              (let [time-str ((time-span {:time :team-time :ktu nil}) value)]
                (if (and (:meta value) (:team-time value))
                  [pf/c-button
                   {:variant :link
                    :class :ncr-m-inline-edit
                    :icon-position :right
                    :icon [w/c-mdi-icon {:icon :pencil}]
                    :on-click
                    (fn [_]
                      (props-timesheet/edit-fragment-property
                        {:id (get-in value [:fragment :id])
                         :on-updated #(ps/pub! [:ncr.reports.core/reload])}))}
                   time-str]
                  time-str))
              :summary
              ((-> {:time :team-time :ktu nil} time-span gc/colorize-border)
               value)
              nil)])))

     (grid/column-accessor :team-total [{:class (cclass :team-total)} "Value Total"]
       (fn [cell-context]
         (let [value (grid/value cell-context)]
           [{:class [(cclass :team-total) (tclass value)]}
            ((case (:type value)
               :data
               (-> :value
                 (gc/stringify-value)
                 (gc/copy-to-value {:from :team-total}))
               :summary
               (-> :value
                 (gc/stringify-value)
                 (gc/copy-to-value {:from :team-total})
                 (gc/colorize-border {:indicator :value}))
               (constantly nil))
             value)])))]))

(defn- c-explain [r-fn {:keys [report] :as meta} {:keys [path] :as ext-data}]
  (let
    [{:keys [value] :as expr} (r-common/from-path report path)]
    (if (some? value)
      (let [meta (merge meta ext-data)]
        (if-let [rows (r-fn meta expr)]
          [grid/grid
           {:style {:width "100%"}
            :class [:ncr-grid :ncr-report-explain-grid :pf-c-table :pf-m-compact]
            :enable-expanding false
            :initial-expand ::grid/all}
           {:columns columns
            :rows rows
            :meta meta}]
          [:pre
           (pprint expr)]))
      [pf/c-empty-state {:variant :xs}
       [pf/c-title {:size :md :heading-level :h4} "No data"]
       [pf/c-empty-state-body "There is no data for this cell"]])))

(def c-explain-project
  (partial c-explain em/r-explain-project))

(def c-explain-team
  (partial c-explain em/r-explain-team))

(def c-explain-plain
  (partial c-explain em/r-explain-plain))
